export { default } from './OneCell';
